import { HeroSection } from "@/containers/HeroSection";

const TacticHeroSection = () => (
  <HeroSection
    title={"EA FC 25 Best Tactics and Codes"}
    content={
      "See the best meta EA FC 25 tactics in our FC Tactics Hub. Use a tactic created by our pros or import your own using the EA Code of your favorite creators."
    }
    canonicalLink={"https://www.easysbc.io/tactics"}
    titleBackgroundColor="bg-[#0C233580]"
  >
    <div className="w-full h-full bg-[#060B0E] flex justify-center">
      <div className="max-w-content relative w-full desktop:h-[186px] touch-device:h-57 flex items-center justify-center mr-12 touch-device:mr-0 touch-device:justify-end touch-device:pr-16 large:pr-64">
        <img
          src={
            import.meta.env.VITE_APP_ASSETS_BASE_URL +
            "/fc25/frontend-assets/tactics/hero-pro-players-desktop.png"
          }
          className="h-full object-cover hidden touch-device:block"
        />
        <img
          src={
            import.meta.env.VITE_APP_ASSETS_BASE_URL +
            "/fc25/frontend-assets/tactics/hero-pro-players-mobile.png"
          }
          className="h-full object-cover block touch-device:hidden"
        />
        <img
          src={
            import.meta.env.VITE_APP_ASSETS_BASE_URL +
            "/fc25/banners/play-like-a-pro/group-5510.png"
          }
          className="absolute hidden touch-device:block touch-device:w-44 top-2 touch-device:top-10 right-4 touch-device:right-8"
        />
      </div>
    </div>
  </HeroSection>
);

export default TacticHeroSection;
